import { Routes } from '@om1/platform-routing'
import { Route, Switch } from 'react-router-dom'
import '../styles/global.css'
import IngestView from '../views/IngestView'

export function IngestPage() {
    return (
        <div
            className='platform-assistant-ui'
            style={{
                overflow: 'auto',
                width: '100%',
                height: '80vh',
                background: '#F5F7FA',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'flex-start',
                maxWidth: '100%',
                flex: '1 1 auto',
                position: 'relative'
            }}
        >
            <Switch>
                <Route path={`/${Routes.INGEST}`} component={IngestView} />
            </Switch>
        </div>
    )
}
